import { FormlySelectOption } from '@ngx-formly/core/select';
import { LeadBusinessType, LeadIndustry, LeadSalutation } from '../type/lead.type';

export const LEAD_INDUSTRY_OPTIONS: FormlySelectOption[] = [
  { value: LeadIndustry.RETAIL, label: 'Retail' },
  { value: LeadIndustry.MANUFACTURING, label: 'Manufacturing' },
  { value: LeadIndustry.WHOLESALE, label: 'Wholesale' },
  { value: LeadIndustry.TRANSPORT, label: 'Transport / Storage' },
  { value: LeadIndustry.FB, label: 'Food & Beverage' },
  { value: LeadIndustry.HOSPITALITY, label: 'Hospitality' },
  { value: LeadIndustry.SERVICES, label: 'Services' },
  { value: LeadIndustry.CONSTRUCTION, label: 'Construction' },
];

export const LEAD_SALUTATION_OPTIONS: FormlySelectOption[] = [
  { value: LeadSalutation.MR, label: 'Mr' },
  { value: LeadSalutation.MS, label: 'Ms' },
  { value: LeadSalutation.MRS, label: 'Mrs' },
  { value: LeadSalutation.MDM, label: 'Mdm' },
  { value: LeadSalutation.DR, label: 'Dr' },
];

export const LEAD_BUSINESS_TYPE_OPTIONS: FormlySelectOption[] = [
  { value: LeadBusinessType.SOLE_PROPRIETORSHIP, label: 'Sole-Proprietorship' },
  { value: LeadBusinessType.PARTNERSHIP, label: 'Partnership' },
  { value: LeadBusinessType.LIMITED_PARTNERSHIP, label: 'Limited Partnership' },
  { value: LeadBusinessType.LIMITED_LIABILITY_PARTNERSHIP, label: 'Limited Liability Partnership' },
  { value: LeadBusinessType.EXEMPT_PRIVATE_COMPANY, label: 'Exempt Private Company' },
];

export const PREFERRED_CONTACT_MODE_OPTIONS: FormlySelectOption[] = [
  { value: 'PHONE', label: 'Phone' },
  { value: 'EMAIL', label: 'Email' },
  { value: 'SMS', label: 'SMS/WhatsApp' },
];
